<kendo-dropdownlist #dropdownlist [data]="[selectedItem]" [textField]="textFielName" [valueField]="valueFielName || textFielName"
  [value]="selectedItem" (open)="toggleDropdown()" (close)="toggleDropdown()" class="kdt-dropdown">
</kendo-dropdownlist>
<div class="kdt-treeview-position" [hidden]="!listOpened">
  <kendo-treeview #myfunckingtreeview [style]="treeListStyle" [nodes]="data || []" [textField]="textFielName || 'libelle'"
    kendoTreeViewSelectable kendoTreeViewHierarchyBinding [childrenField]="childrenListName" (expandedKeys)="(true)"
    [(selectedKeys)]="selectedKeys" (blur)="onFocusLost()">
  </kendo-treeview>
</div>
